<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-service" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        [required]="required"
      />
      <mat-icon
        matSuffix
        fontIcon="bosch-ic-add-frame"
        *ngIf="context === 'budget'"
        (click)="addNewService()"
        id="serviceAutoComplete-input-icon-add"
      ></mat-icon>
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let service of services"
          (onSelectionChange)="handleServiceChange($event, service)"
          [value]="service.serviceCode + ' - ' + service.displayName"
          class="autocomplete"
        >
          {{ service.serviceCode }} - {{ service.displayName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="!this.searchForm.valid">{{
        requiredText || "required-service" | translate
      }}</mat-error>
    </mat-form-field>
  </div>
</form>
